import React from 'react';
import { Global } from '@emotion/react';
import { cssReset } from 'ui_system/token_auth/styles_root';
import { Logo } from './logo';
import { Container, H1, BareHR, BodyText } from './PrivacyStyles';

const PrivacyVerificationEmailSent = () => (
  <React.Fragment>
    <Global styles={cssReset({})} />
    <Logo />
    <BareHR />
    <Container>
      <H1>One more step!</H1>
      <BodyText>
        A verification link has been sent to your email address. Check your
        email for a link to verify your email address and we will start the
        request process. Please note that for security purposes, the link will
        expire after 48 hours.
      </BodyText>
    </Container>
  </React.Fragment>
);

export default PrivacyVerificationEmailSent;
